/*
 * @Description:
 * @Author: 赵大壮
 * @Date: 2021-12-06 17:19:11
 * @LastEditTime: 2023-10-08 14:00:54
 * @LastEditors: 赵大壮
 */
import nyMessageToast from "@/utils/NYMessageToast";
import { Component, Vue, Inject } from "vue-property-decorator";
import DZUserService from "../service/DZUserService";


@Component
export default class Index extends Vue {

    dZModelUser = new DZUserService();

    dzUser = this.$store.state.user;

    created() {
    }

    mounted() {
        this.dZModelUser.s_username = this.dzUser?.account ?? '';
    }

    beforeDestroy() {

    }

    /**
     * 登录方法
     */
    doLogin() {
        this.dZModelUser.doLogin((data) => {
            console.log(data)
            nyMessageToast.success("登录成功")
            this.$store.commit("SET_USER", data)
            this.$store.state.user.saveUserData(data);
            this.$router.push({ path: '/' });
        })
    }

}
